<template>
  <!--
    Botón "My items" (filtro «solo mis registros», `ownerScope=mine`).
    Lo comparten el listado dinámico y el dashboard (ticket #424), así que se ve
    y se comporta igual en los dos lados. Quien lo usa decide qué filtra.
  -->
  <button
    type="button"
    class="btn btn-sm gt-my-items-btn"
    :class="{ 'gt-my-items-btn-on': active }"
    :title="active ? $t('Clear') : $t('MyItems')"
    @click="$emit('toggle')"
  >
    <i class="fas fa-user me-1"></i>{{ $t("MyItems") }}
    <i v-if="active" class="fas fa-times ms-1"></i>
  </button>
</template>

<script>
export default {
  name: "MyItemsButton",
  props: {
    /** Filtro prendido. */
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/*
 * Naranja propio, distinto del azul de la barra. Va scoped a propósito: el
 * `bootstrap.css` se carga después del CSS global y su `.btn` redefine estas
 * mismas variables; con el atributo del scope el selector pesa más y le gana.
 */
.gt-my-items-btn {
  --bs-btn-color: #e8590c;
  --bs-btn-border-color: rgba(232, 89, 12, 0.55);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #e8590c;
  --bs-btn-hover-border-color: #e8590c;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c44a09;
  --bs-btn-active-border-color: #c44a09;
  --bs-btn-focus-shadow-rgb: 232, 89, 12;
}

.gt-my-items-btn-on {
  --bs-btn-color: #fff;
  --bs-btn-bg: #e8590c;
  --bs-btn-border-color: #e8590c;
  --bs-btn-hover-bg: #c44a09;
  --bs-btn-hover-border-color: #c44a09;
}
</style>
